import {ReviewState} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

export function reviewStateLabel(state: ReviewState, dismissedState: ReviewState = ReviewState.UNSPECIFIED): string {
  switch (state) {
    case ReviewState.APPROVED:
      return 'approved'
    case ReviewState.CHANGES_REQUESTED:
      return 'changes requested'
    case ReviewState.COMMENTED:
      return 'commented'
    case ReviewState.DISMISSED: {
      return dismissedReviewLabel(dismissedState)
    }
    case ReviewState.PENDING:
      return 'pending'
    case ReviewState.UNSPECIFIED:
      return 'reviewed'
  }
}

export function dismissedReviewLabel(dismissedState: ReviewState): string {
  switch (dismissedState) {
    case ReviewState.APPROVED:
      return 'previously approved'
    case ReviewState.CHANGES_REQUESTED:
      return 'previously requested changes'
    case ReviewState.COMMENTED:
      return 'previously commented'
    default:
      return 'previously reviewed'
  }
}
